module.exports = __webpack_public_path__ + "media/country_flags/mw-30408e89.png";